module.exports = __webpack_public_path__ + "img/touxiang.3737e46a.png";